var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 100,
    height: 100,
    rx: 30,
    fill: "#47B638"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6665 60.9611L66.8284 54.123C64.3863 51.6808 60.2346 52.6578 59.2577 55.8325C58.525 58.0305 56.0829 59.2516 53.8849 58.7631C49.0005 57.542 42.4067 51.1924 41.1856 46.0638C40.4529 43.8657 41.9182 41.4235 44.1162 40.691C47.291 39.7141 48.2679 35.5624 45.8257 33.1202L38.9876 26.2821C37.0339 24.5726 34.1033 24.5726 32.3937 26.2821L27.7536 30.9223C23.1135 35.8066 28.242 48.7502 39.7203 60.2284C51.1985 71.7066 64.1421 77.0795 69.0264 72.1951L73.6665 67.5549C75.3762 65.6012 75.3762 62.6706 73.6665 60.9611Z",
    fill: "#47B638"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(26 25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f63725f320d79b719fe789d7afdcdf5b.svg";
export { ForwardRef as ReactComponent };